<template>
  <div class="st-detail">
    <!-- warm success toast -->
    <v-snackbar v-model="alert" timeout="3000" color="transparent" elevation="0">
      <div class="st-toast">
        <hero-icon :icon="CheckCircleIcon" :size="18" />
        <span>Datos actualizados con éxito</span>
      </div>
    </v-snackbar>

    <!-- employee header -->
    <div class="st-header">
      <div class="st-avatar-wrap">
        <div class="st-avatar">
          <img
            v-if="employee.avatarUrl"
            :src="url + employee.avatarUrl"
            class="st-avatar__img"
            alt=""
          />
          <span v-else class="st-avatar__initial">{{ initial }}</span>
        </div>

        <button type="button" class="st-cam" @click="openChangePicture" title="Cambiar foto">
          <hero-icon :icon="CameraIcon" :size="14" />
        </button>

        <input
          class="d-none"
          ref="picture"
          type="file"
          accept="image/*"
          @change="uploadPicture"
        />
      </div>

      <div class="st-header__text">
        <h2 class="st-header__name">{{ attributes.name || "Sin nombre" }}</h2>
        <p class="st-header__meta">{{ headerMeta }}</p>
      </div>
    </div>

    <!-- Analytics -->
    <section class="st-section">
      <header class="st-section__head">
        <hero-icon :icon="ChartIcon" :size="14" />
        <span>Gestiones</span>
      </header>
      <div class="st-section__body">
        <staff-dashboard :id="employee.id" />
      </div>
    </section>

    <!-- Credenciales -->
    <section class="st-section">
      <header class="st-section__head">
        <hero-icon :icon="KeyIcon" :size="14" />
        <span>Credenciales</span>
      </header>
      <div class="st-section__body">
        <v-form v-model="validUser" ref="userForm" lazy-validation>
          <v-row dense>
            <v-col class="py-1" cols="12" md="6">
              <div class="st-field-label">
                <hero-icon :icon="EnvelopeIcon" :size="13" />
                <span>E-mail</span>
              </div>
              <v-text-field
                v-model="userAttributes.email"
                :rules="required"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col class="py-1" cols="12" md="6">
              <div class="st-field-label">
                <hero-icon :icon="LockIcon" :size="13" />
                <span>Contraseña</span>
              </div>
              <v-text-field
                v-model="userAttributes.password"
                hint="Opcional. Rellenar el campo sobreescribe la contraseña actual."
                persistent-hint
                type="password"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col class="py-1" cols="12" md="6">
              <div class="st-field-label">
                <hero-icon :icon="IdentificationIcon" :size="13" />
                <span>Permisos</span>
              </div>
              <v-select
                v-model="role"
                :items="userRoles"
                :rules="required"
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>

          <div class="st-footer">
            <v-btn depressed color="accent" class="rounded-lg" @click="editUser">
              Guardar
            </v-btn>
          </div>
        </v-form>
      </div>
    </section>

    <!-- Datos de contacto -->
    <section class="st-section">
      <header class="st-section__head">
        <hero-icon :icon="UserIcon" :size="14" />
        <span>Datos de contacto</span>
      </header>
      <div class="st-section__body">
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-row dense>
            <v-col class="py-1" cols="12" md="6">
              <div class="st-field-label">
                <hero-icon :icon="IdentificationIcon" :size="13" />
                <span>Nombre</span>
              </div>
              <v-text-field
                v-model="attributes.name"
                :rules="required"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col class="py-1" cols="12" md="6">
              <div class="st-field-label">
                <hero-icon :icon="PhoneIcon" :size="13" />
                <span>Número de teléfono</span>
              </div>
              <v-text-field
                v-model="attributes.number"
                :rules="required"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col class="py-1" cols="12" md="6">
              <div class="st-field-label">
                <hero-icon :icon="TagIcon" :size="13" />
                <span>Tipo de operación</span>
              </div>
              <v-select
                v-model="attributes.operationType"
                :items="operationTypes"
                :rules="required"
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </v-col>

            <v-col
              v-if="attributes.operationType && attributes.operationType == 'rent'"
              class="py-1"
              cols="12"
              md="6"
            >
              <div class="st-field-label">
                <hero-icon :icon="BriefcaseIcon" :size="13" />
                <span>Cargo</span>
              </div>
              <v-select
                v-model="attributes.rol"
                :items="roles"
                :rules="required"
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </v-col>

            <v-col class="py-1" cols="12" md="6">
              <div class="st-field-label">
                <hero-icon :icon="BuildingIcon" :size="13" />
                <span>Tipo de propiedad</span>
              </div>
              <v-select
                v-model="attributes.propertyTypes"
                multiple
                :items="propertyTypes"
                clearable
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </v-col>

            <v-col class="py-1" cols="12" md="6">
              <div class="st-field-label">
                <hero-icon :icon="MapPinIcon" :size="13" />
                <span>Sucursal</span>
              </div>
              <v-select
                v-model="attributes.city"
                clearable
                :items="cities"
                outlined
                dense
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>

          <div class="st-footer st-footer--split">
            <delete-staff :id="employee.id" @deleted="$emit('deleted')"></delete-staff>

            <v-btn depressed color="accent" class="rounded-lg" @click="editStaff">
              Guardar
            </v-btn>
          </div>
        </v-form>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EditStaff } from "@/graphql/mutations/staff";
import { EditUserByAdmin } from "@/graphql/mutations/user";
import StaffDashboard from "./Dashboard";
import DeleteStaff from "./Delete";

import HeroIcon from "@/components/shared/HeroIcon";
import UserIcon from "heroicons/24/outline/user.svg";
import EnvelopeIcon from "heroicons/24/outline/envelope.svg";
import LockIcon from "heroicons/24/outline/lock-closed.svg";
import KeyIcon from "heroicons/24/outline/key.svg";
import IdentificationIcon from "heroicons/24/outline/identification.svg";
import PhoneIcon from "heroicons/24/outline/phone.svg";
import TagIcon from "heroicons/24/outline/tag.svg";
import BriefcaseIcon from "heroicons/24/outline/briefcase.svg";
import BuildingIcon from "heroicons/24/outline/building-office.svg";
import MapPinIcon from "heroicons/24/outline/map-pin.svg";
import CameraIcon from "heroicons/24/outline/camera.svg";
import CheckCircleIcon from "heroicons/24/outline/check-circle.svg";
import ChartIcon from "heroicons/24/outline/chart-bar.svg";

export default {
  data() {
    return {
      UserIcon,
      EnvelopeIcon,
      LockIcon,
      KeyIcon,
      IdentificationIcon,
      PhoneIcon,
      TagIcon,
      BriefcaseIcon,
      BuildingIcon,
      MapPinIcon,
      CameraIcon,
      CheckCircleIcon,
      ChartIcon,
      valid: true,
      validUser: true,
      alert: false,
      roles: ["Visitas", "Administración"],
      cities: ["Reconquista", "Avellaneda"],
      operationTypes: [
        {
          text: "Ventas",
          value: "sell"
        },
        {
          text: "Alquileres",
          value: "rent"
        }
      ],
      propertyTypes: [
        {
          text: this.$t(
            "property.create.type.fields.property_types.country_house"
          ),
          value: "country_house"
        },
        {
          text: this.$t("property.create.type.fields.property_types.apartment"),
          value: "apartment"
        },
        {
          text: this.$t("property.create.type.fields.property_types.salon"),
          value: "salon"
        },
        {
          text: this.$t("property.create.type.fields.property_types.warehouse"),
          value: "warehouse"
        },
        {
          text: this.$t("property.create.type.fields.property_types.parking"),
          value: "parking"
        },
        {
          text: this.$t("property.create.type.fields.property_types.shed"),
          value: "shed"
        },
        {
          text: this.$t("property.create.type.fields.property_types.house"),
          value: "house"
        },
        {
          text: this.$t("property.create.type.fields.property_types.farm"),
          value: "farm"
        },
        {
          text: this.$t("property.create.type.fields.property_types.terrain"),
          value: "terrain"
        }
      ],
      required: [v => !!v || "Campo obligatorio"],
      role: null,
      userRoles: [
        {
          text: "Gerente",
          value: "admin"
        },
        {
          text: "Ventas",
          value: "sales"
        },
        {
          text: "Administración",
          value: "gendev"
        },
        {
          text: "Propiedades",
          value: "properties"
        }
      ],
      userAttributes: {
        email: null,
        password: null
      },
      avatar: null,
      attributes: {
        name: null,
        rol: null,
        operationType: null,
        propertyTypes: [],
        number: null,
        city: null
      }
    };
  },

  props: {
    employee: {
      required: true,
      type: Object
    }
  },

  created() {
    this.syncFromEmployee();
  },

  methods: {
    syncFromEmployee() {
      Object.keys(this.attributes).forEach(k => {
        this.attributes[k] = this.employee[k];
      });

      Object.keys(this.userAttributes).forEach(k => {
        this.userAttributes[k] = this.employee.user[k];
      });

      this.role = this.employee.user.displayRoles[0];
    },

    editStaff() {
      if (this.$refs.form.validate()) {
        this.$apollo
          .mutate({
            mutation: EditStaff,
            variables: {
              input: {
                attributes: this.attributes,
                id: this.employee.id
              }
            }
          })
          .then(res => {
            this.alert = true;
          });
      }
    },

    editUser() {
      if (this.$refs.userForm.validate()) {
        this.$apollo
          .mutate({
            mutation: EditUserByAdmin,
            variables: {
              input: {
                attributes: this.userAttributes,
                role: this.role,
                id: this.employee.user.id
              }
            }
          })
          .then(res => {
            this.alert = true;
          });
      }
    },

    openChangePicture() {
      this.$refs.picture.click();
    },

    uploadPicture(e) {
      var file = e.target.files[0];

      this.$apollo
        .mutate({
          mutation: EditStaff,
          variables: {
            input: {
              id: this.employee.id,
              attributes: {
                avatar: file
              }
            }
          }
        })
        .then(res => {
          // refresh the rail + this pane (re-resolves the employee prop with the
          // new avatarUrl) instead of a full SPA reload
          this.$emit("reload");
          this.alert = true;
        });
    }
  },

  computed: {
    ...mapGetters(["url"]),

    initial() {
      const n = this.attributes.name || this.employee.name || "";
      return n.trim().charAt(0).toUpperCase() || "?";
    },

    headerMeta() {
      const parts = [];
      const op = this.operationTypes.find(
        o => o.value === this.attributes.operationType
      );
      if (op) parts.push(op.text);
      if (this.attributes.city) parts.push(this.attributes.city);
      return parts.join(" · ") || "Personal";
    }
  },

  watch: {
    employee() {
      this.syncFromEmployee();
    }
  },

  components: { StaffDashboard, DeleteStaff, HeroIcon }
};
</script>

<style scoped>
.st-detail {
  height: 100%;
  overflow-y: auto;
  padding: 16px;
}

@media (min-width: 960px) {
  .st-detail {
    padding: 20px 24px;
  }
}

/* header */
.st-header {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.st-avatar-wrap {
  position: relative;
  flex: none;
}

.st-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #1a1814;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.st-avatar__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.st-avatar__initial {
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.st-cam {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ece7de;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #756f64;
  box-shadow: 0 4px 12px -6px rgba(40, 33, 22, 0.3);
  transition: color 0.15s ease, border-color 0.15s ease;
}
.st-cam:hover {
  color: #b52118;
  border-color: #dcd4c6;
}

.st-header__text {
  min-width: 0;
}
.st-header__name {
  font-size: 19px;
  font-weight: 700;
  color: #1a1814;
  line-height: 1.2;
  margin: 0;
}
.st-header__meta {
  font-size: 13px;
  color: #756f64;
  margin: 3px 0 0;
}

/* section cards */
.st-section {
  background: #fff;
  border: 1px solid #ece7de;
  border-radius: 12px;
  box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18);
  margin-bottom: 16px;
  overflow: hidden;
}

.st-section__head {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  border-bottom: 1px solid #ece7de;
  background: #faf8f4;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #756f64;
}
.st-section__head .hero-icon {
  color: #a39a8c;
}

.st-section__body {
  padding: 16px;
}

/* field labels */
.st-field-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: #756f64;
  margin-bottom: 5px;
}
.st-field-label .hero-icon {
  color: #a39a8c;
}

/* footers */
.st-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}
.st-footer--split {
  justify-content: space-between;
}

/* warm toast */
.st-toast {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: #e3f3e8;
  color: #2c6e49;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 13.5px;
  font-weight: 600;
}
.st-toast .hero-icon {
  color: #2c6e49;
}

/* rounded outlined fieldsets */
.st-detail ::v-deep .v-text-field--outlined fieldset {
  border-radius: 10px;
}
</style>
